import {
  DATA_CONNECTOR_CREATE_COLLECTION_WITH_DIRECTUS_BEGIN,
  DATA_CONNECTOR_CREATE_COLLECTION_WITH_DIRECTUS_SUCCESS,
  DATA_CONNECTOR_CREATE_COLLECTION_WITH_DIRECTUS_FAILURE,
  DATA_CONNECTOR_CREATE_COLLECTION_WITH_DIRECTUS_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import axios from 'axios';
import { toast } from 'react-toastify';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';

export function createCollectionWithDirectus(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_CREATE_COLLECTION_WITH_DIRECTUS_BEGIN,
    });
    const { version, projectId } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/directus/create-collection`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_CREATE_COLLECTION_WITH_DIRECTUS_SUCCESS,
            data: res,
          });
          Mixpanel.track('Created Collection', {
            uuid: res.data.uuid,
            colletionName: res.data.colletionName,
          });
          toast.success('Collection Created Successfully !');
          resolve(res);
        },
        (err) => {
          const errMsg = getErrorMessageFromResponse(err.response) || ` to create Collection`;
          console.log('err222', err);
          toast.error(`Failed: ${errMsg}`);
          Mixpanel.track('Failed to creat collection');
          dispatch({
            type: DATA_CONNECTOR_CREATE_COLLECTION_WITH_DIRECTUS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissCreateCollectionWithDirectusError() {
  return {
    type: DATA_CONNECTOR_CREATE_COLLECTION_WITH_DIRECTUS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_CREATE_COLLECTION_WITH_DIRECTUS_BEGIN:
      return {
        ...state,
        createCollectionWithDirectusPending: true,
        createCollectionWithDirectusError: null,
      };

    case DATA_CONNECTOR_CREATE_COLLECTION_WITH_DIRECTUS_SUCCESS:
      return {
        ...state,
        createCollectionWithDirectusPending: false,
        createCollectionWithDirectusError: null,
      };

    case DATA_CONNECTOR_CREATE_COLLECTION_WITH_DIRECTUS_FAILURE:
      return {
        ...state,
        createCollectionWithDirectusPending: false,
        createCollectionWithDirectusError: action.data.error,
      };

    case DATA_CONNECTOR_CREATE_COLLECTION_WITH_DIRECTUS_DISMISS_ERROR:
      return {
        ...state,
        createCollectionWithDirectusError: null,
      };

    default:
      return state;
  }
}
